export const PRODUCTS = [
  {
    id : 1,
    name: "P&B / Blank Mould",
    videoUrl : "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "1.jpg",
    image2: "1.png"
  },
  {
    id : 2,
    name: "P&B / Neck Ring",
    image1: "2.jpg",
    image2: "2.png"
  },
  {
    id : 3,
    name: "Press / Mould",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "3.jpg",
    image2: "3.png"
  },
  {
    id : 4,
    name: "Press / Plunger",
    image1: "4.jpg",
    image2: "4.png"
  },
  {
    id : 5,
    name: "P&B / Ring",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "5.jpg",
    image2: "5.png"
  },
  {
    id : 6,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "6.jpg",
    image2: "6.png"
  },
  {
    id : 7,
    name: "P&B / Blank Mould",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "7.jpg",
    image2: "7.png"
  },
  {
    id : 8,
    name: "P&B / Ring",
    image1: "8.jpg",
    image2: "8.png"
  },
  {
    id : 9,
    name: "P&B / Blow Mould",
    image1: "9.jpg",
    image2: "9.png"
  },
  {
    id : 10,
    name: "P&B Burner",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "10.jpg",
    image2: "10.png"
  },
  {
    id : 11,
    name: "Press / Bottom Plate",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "11.jpg",
    image2: "11.png"
  },
  {
    id : 12,
    name: "P&B / Burner",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "12.jpg",
    image2: "12.png"
  },
  {
    id : 13,
    name: "P&B / Vacuum Head",
    image1: "13.jpg",
    image2: "13.png"
  },
  {
    id : 14,
    name: "Spare / Parts Spare Part",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "14.jpg",
    image2: "14.png"
  },
  {
    id : 15,
    name: "IS / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "15.jpg",
    image2: "15.png"
  },
  {
    id : 16,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "16.jpg",
    image2: "16.png"
  },
  {
    id : 17,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "17.jpg",
    image2: "17.png"
  },
  {
    id : 18,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "18.jpg",
    image2: "18.png"
  },
  {
    id : 19,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "19.jpg",
    image2: "19.png"
  },
  {
    id : 20,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "20.jpg",
    image2: "20.png"
  },
  {
    id : 21,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "21.jpg",
    image2: "21.png"
  },
  {
    id : 22,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "22.jpg",
    image2: "22.png"
  },
  {
    id : 23,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "23.jpg",
    image2: "23.png"
  },
  {
    id : 24,
    name: "Press / Mould",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "24.jpg",
    image2: "24.png"
  },
  {
    id : 25,
    name: "Press / Mould",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "25.jpg",
    image2: "25.png"
  },
  {
    id : 26,
    name: "Press / Mould",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "26.jpg",
    image2: "26.png"
  },
  {
    id : 27,
    name: "Press / Ring",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "27.jpg",
    image2: "27.png"
  },
  {
    id : 28,
    name: "Press / Ring",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "28.jpg",
    image2: "28.png"
  },
  {
    id : 29,
    name: "Press / Ring",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "29.jpg",
    image2: "29.png"
  },
  {
    id : 30,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "30.jpg",
    image2: "30.png"
  },
  {
    id : 31,
    name: "IS / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "31.jpg",
    image2: "31.png"
  },
  {
    id : 32,
    name: "IS / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "32.jpg",
    image2: "32.png"
  },
  {
    id : 33,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "33.jpg",
    image2: "33.png"
  },
  {
    id : 34,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "34.jpg",
    image2: "34.png"
  },
  {
    id : 35,
    name: "Press / Plunger",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "35.jpg",
    image2: "35.png"
  },
  {
    id : 36,
    name: "Press / Mould",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "36.jpg",
    image2: "36.png"
  },
  {
    id : 37,
    name: "Press / Mould",
    videoUrl: "https://www.youtube.com/embed/oydna7xDb_0",
    image1: "37.jpg",
    image2: "37.png"
  }
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/mock-products.ts